'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PlayerHeader = require('../PlayerHeader');

var _PlayerHeader2 = _interopRequireDefault(_PlayerHeader);

var _withContentCardFooter = require('../../hocs/withContentCardFooter');

var _withContentCardFooter2 = _interopRequireDefault(_withContentCardFooter);

var _ContentCardText = require('../ContentCardText');

var _ContentCardText2 = _interopRequireDefault(_ContentCardText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RotoPlayerNewsContentCard = function RotoPlayerNewsContentCard(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_PlayerHeader2.default, {
      headshotUrl: props.headshotUrl,
      name: props.name
    }),
    _react2.default.createElement(_ContentCardText2.default, {
      text: props.title,
      isLarge: props.isLarge,
      isImageCard: false
    })
  );
};

RotoPlayerNewsContentCard.propTypes = {
  headshotUrl: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  isLarge: _propTypes2.default.string
};

RotoPlayerNewsContentCard.defaultProps = {
  isLarge: ''
};

RotoPlayerNewsContentCard.displayName = 'RotoPlayerNewsContentCard';

exports.default = (0, _withContentCardFooter2.default)(RotoPlayerNewsContentCard);